'use strict';exports.__esModule = true;exports.deleteCoupon = exports.checkDiscountCode = undefined;var _index = require('axios/index');var _index2 = _interopRequireDefault(_index);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _couponsConfig = require('../../containers/DiscountCouponContainer/couponsConfig');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var




promise = _reduxLoop.Effects.promise;

var checkDiscountCode = (0, _reduxAct.createAction)('/CHECK_CODE');
var checkCodeSuccess = (0, _reduxAct.createAction)('/CHECK_CODE_SUCCESS');
var checkCodeFail = (0, _reduxAct.createAction)('/CHECK_CODE_FAIL');
var deleteCoupon = (0, _reduxAct.createAction)('/DELETE_COUPON');

var initialState = {
  loading: false,
  loaded: false,
  data: null,
  error: null };


var checkCodeHandlerSuccess = function checkCodeHandlerSuccess(state, response) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: response });};


var checkCodeHandlerFail = function checkCodeHandlerFail(state, action) {
  console.error(action);
  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: action,
    data: null });

};

var deleteCouponHandler = function deleteCouponHandler() {return Object.assign({}, initialState);};

var fetchReceive = function fetchReceive(_ref) {var code = _ref.code,type = _ref.type,isAgent = _ref.isAgent;return _index2.default.
  post('/users/discount/verify', {
    discount_code: code,
    discount_type: type,
    is_agent: isAgent }).

  then(function () {return checkCodeSuccess({ type: code });}, checkCodeFail);};

var checkCodeHandler = function checkCodeHandler(state, data) {return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true, error: null }), promise(fetchReceive, data));};

var discountCoupon = (0, _reduxAct.createReducer)(function (on) {
  on(checkDiscountCode, checkCodeHandler);
  on(checkCodeSuccess, checkCodeHandlerSuccess);
  on(checkCodeFail, checkCodeHandlerFail);
  on(deleteCoupon, deleteCouponHandler);
}, initialState);exports.


checkDiscountCode = checkDiscountCode;exports.
deleteCoupon = deleteCoupon;exports.default =


discountCoupon;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/discountCoupon.js
// module id = 1269
// module chunks = 0